"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_cluster_1 = require("./leaf-cluster");
var merged_cluster_1 = require("./merged-cluster");
var ClusterFactory = /** @class */ (function () {
    function ClusterFactory() {
        this.idCounter = 0;
    }
    ClusterFactory.prototype.createLeafCluster = function (object) {
        return new leaf_cluster_1.LeafCluster(this.idCounter++, object);
    };
    ClusterFactory.prototype.createMergedCluster = function (c1, c2, distance) {
        return new merged_cluster_1.MergedCluster(this.idCounter++, c1, c2, distance);
    };
    return ClusterFactory;
}());
exports.ClusterFactory = ClusterFactory;
